export default "__VITE_PUBLIC_ASSET__f23a68d3__"